/**
 * Build an authenticated URL for a protected file endpoint.
 *
 * The backend serves uploads at /api/uploads/* and accepts the JWT either
 * as an Authorization header or as a ?token= query parameter.
 * Browser-native requests (<img>, <iframe>, <a href>) cannot set headers,
 * so we append the token as a query parameter.
 *
 * Handles legacy URLs stored in the DB as /uploads/... and normalises them
 * to the new /api/uploads/... path automatically.
 */
export function getAuthFileUrl(filePath: string | undefined | null): string {
  if (!filePath) return '';

  const token = localStorage.getItem('token') || '';

  // Normalise legacy /uploads/ paths to the protected /api/uploads/ endpoint
  let apiPath = filePath.startsWith('/uploads/')
    ? filePath.replace('/uploads/', '/api/uploads/')
    : filePath;

  const sep = apiPath.includes('?') ? '&' : '?';
  return `${apiPath}${sep}token=${encodeURIComponent(token)}`;
}
